// Layout component renders navigation and footer components
import React, { Fragment, useContext } from "react";

import classes from "./Layout.module.css";

import MainNavigation from "./MainNavigation";
import ProgressBar from "../shared/ProgressBar";
import Footer from "./Footer";

import { ProgressContext } from "../context/progress-context";

const Layout = (props) => {
  const progress = useContext(ProgressContext);

  return (
    <Fragment>
      <MainNavigation />
      <ProgressBar percentage={progress.percentage} />
      <main className={classes.main}>{props.children}</main>
      <Footer />
    </Fragment>
  );
};

export default Layout;
